<div class="booble-backdrop">
  <div class="xp-modal xp-modal-cadastro">
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm"
    >
      <div class="modal-content">
        <div class="modal-dialog-scrollable-general">
          <div class="modal-header">
            <div
              class="col-md-12 d-flex justify-content-between modal-header-border"
            >
              <div>
                <div class="modal-title-new">
                  Confirmação da criação do boleto
                </div>
              </div>

              <div
                (click)="closeModal()"
                class="close-icon tappable align-self-center"
              >
                <img src="assets/image/close-modal-icon.svg" />
              </div>
            </div>
          </div>

          <div class="modal-body-content">
            <p class="p-text-grey font-weight-300 mg-top-8">
              Para confirmação da criação do boleto, adicione o número do boleto
              gerado.
            </p>

            <div [formGroup]="formExchange" class="row mt-4">
              <div class="col-md-12">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Código do boleto</mat-label>
                  <input
                    matInput
                    formControlName="SlipCode"
                    type="text"
                    class=""
                    name="name"
                    required
                  />
                  <mat-error
                    class="text-danger"
                    *ngIf="
                      formExchange.controls['SlipCode'].touched &&
                      formExchange.controls['SlipCode'].errors?.required
                    "
                  >
                    Código do boleto obrigatório</mat-error
                  >
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer-new">
          <button
            type="button"
            (click)="closeModal()"
            [style.width]="'95px'"
            class="btn-outline-primary btn"
            type="button"
          >
            Fechar
          </button>
          <button
            type="button"
            [disabled]="formExchange.invalid || loading"
            (click)="exchangeConfirm()"
            class="btn-footer btn btn-dark-primary-blue"
            type="button"
          >
            Confirmar
            <span
              class="spinner-border spinner-border-sm"
              *ngIf="loading"
            ></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
